import { BaseModule } from '@core/base/module/base-module'
import { AccountService } from '@core/services/api-gateway'
import { AuthService } from '@core/services/auth'
import * as Sentry from '@sentry/react'

const state: IUserState = {
    currentUser: null,
    loading: false,
    error: false,
    last_fetched: '',
}

class User extends BaseModule<IUserState> {
    constructor(state: IUserState) {
        super(state, 'user.module')

        this.$eventBus.on('app_initialized', async ({ user }) => {
            this.store.setKey('currentUser', user)
            Sentry.setUser({ email: user.email?.value })
        })
    }

    get currentUser() {
        return this.store.get().currentUser
    }

    async onLoad(forced = false) {
        const store = this.store

        if (!store.get().last_fetched || forced) {
            await this.getMFA()
        }
    }

    async getMFA() {
        const store = this.store

        store.setKey('last_fetched', Date.now().toString())

        store.setKey('loading', true)

        const mfa_enabled = await AccountService.getUserMFA()
        store.setKey('currentUser', {
            ...this.currentUser,
            mfa_active: mfa_enabled,
        } as TCurrentUser)

        store.setKey('loading', false)
    }

    async toggleMFA(on: boolean) {
        const store = this.store

        store.setKey('loading', true)

        await AccountService.toggleUserMFA(on)

        store.setKey('currentUser', {
            ...this.currentUser,
            mfa_active: on,
        } as TCurrentUser)

        store.setKey('loading', false)

        if (on) {
            await AuthService.login()
        }
    }

    async resetMFA() {
        await AccountService.toggleUserMFA(false)
        await AccountService.toggleUserMFA(true)
        await AuthService.login()
    }

    async editUser(firstName: string, lastName: string, jobTitle: string) {
        let success = false
        this.store.setKey('loading', true)

        const result = await AccountService.editUser(
            firstName,
            lastName,
            jobTitle
        )

        if (result) {
            const currentUser = {
                ...this.store.get().currentUser,
                first_name: firstName,
                last_name: lastName,
                job_title: jobTitle,
            }
            this.store.setKey('currentUser', currentUser as TCurrentUser)
            success = true
        }

        this.store.setKey('loading', false)

        return success
    }
}

export const UserModule = new User(state)
